import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { APP_HOME_ROUTE } from "@/common/routes.common";
import { useDashboardVisibility } from "../hooks/useDashboardVisibility";
import type { DashboardPageKey } from "../visibility";

interface DashboardPageRouteProps {
  readonly page: DashboardPageKey;
  readonly children: ReactNode;
}

/**
 * Renders a dashboard page only when the Mezza Hub left it visible for the merchant; otherwise sends the
 * user to the first visible dashboard page, or to the regular app when every page is hidden.
 * `DashboardLayout` holds the routed page back until the visibility settings have loaded.
 */
export function DashboardPageRoute({ page, children }: DashboardPageRouteProps) {
  const { isLoading, isPageVisible, firstVisibleRoute } = useDashboardVisibility();

  if (isLoading) {
    return null;
  }

  if (!isPageVisible(page)) {
    return <Navigate to={firstVisibleRoute ?? APP_HOME_ROUTE} replace />;
  }

  return <>{children}</>;
}
